module.exports = __webpack_public_path__ + "assets/img/29_212.527cc360.jpg";